import {
  faCog,
  faDollar,
  faList,
  faPrint,
  faTh,
  faUpload,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

export const Pantallas = [
  {
    titulo: "Pedidos pendientes",
    permisos: ["cajero"],
    url: "/pedidos/cerrados",
    icon: faUser,
  },
  {
    titulo: "Pedidos para imprimir",
    permisos: ["impresor"],
    url: "/pedidos/print",
    icon: faPrint,
  },
  {
    titulo: "Pedidos del día",
    permisos: ["cajero", "local"],
    url: "/pedidos",
    icon: faList,
  },
  {
    titulo: "Ubicaciones",
    permisos: ["cajero"],
    url: "/ubicaciones",
    icon: faUsers,
  },
  {
    titulo: "Subidas",
    permisos: ["cajero"],
    url: "/subidas",
    icon: faUpload,
  },
  {
    titulo: "Fotos",
    permisos: ["cajero", "fotografo"],
    url: "/fotos",
    icon: faTh,
  },
  {
    titulo: "Cuentas",
    permisos: ["cajero", "contador", "observador"],
    url: "/cuentas",
    icon: faDollar,
  },
  {
    titulo: "Config",
    permisos: ["admin"],
    url: "/config",
    icon: faCog,
  },
  {
    titulo: "Comisiones",
    permisos: ["fotografo"],
    url: "/miscomisiones",
    icon: faDollar,
  },
  {
    titulo: "Informes",
    permisos: ["admin"],
    url: "/informes",
    icon: faList,
  },
  /*  {
    titulo: "Subidor",
    permisos: ["fotografo"],
    url: "/subidor",
    icon: faUpload,
  },*/
] as const;
